module.exports = __webpack_public_path__ + "static/media/wcqi_logo3.22e19433.png";